import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

const AuthContext = createContext({ user: null, loading: true });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if we have stored user info in localStorage
    const storedUid = localStorage.getItem('userUid');
    const storedEmail = localStorage.getItem('userEmail');
    
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {

      if (currentUser) {
        // Ensure localStorage is updated
        localStorage.setItem('userAuthenticated', 'true');
        localStorage.setItem('userAuthTime', new Date().toISOString());
        localStorage.setItem('userEmail', currentUser.email || 'unknown');
        localStorage.setItem('userUid', currentUser.uid || 'unknown');
      }
      
      setUser(currentUser);
      setLoading(false);
    });
    
    return unsubscribe;
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { auth }; // Re-export auth for use in other files
